module.exports = __webpack_public_path__ + "images/pages/halloween_lp/MV_BgStripe_web_9e52d4bc222ebf727890a5178b706b91.png";